export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export const UPDATE_MENSAGENS_CHAT_NAO_LIDAS = "UPDATE_MENSAGENS_CHAT_NAO_LIDAS";
